import { doFetchRequest } from '@r1-frontend/do-request/doFetchRequest';
import { cityByIp } from '@r1-frontend/api-domru/r1-platform-gateway/v1/city-by-ip';
import { IResponseDto } from '@r1-frontend/api-domru/r1-platform-gateway/v1/city-by-ip/dto/IResponseDto';

export const getIpData = async(ip: string) => {
    const response = await doFetchRequest.r1PlatformGateway<IResponseDto>(
        cityByIp(ip),
    );

    if (response.isSuccess) {
        const { result } = response.payload;

        if (result) {
            const { name_ru: name, region_iso_code: region } = result;
            return {
                name,
                region,
            };
        }
    }
};
